import React from 'react';
import { FadeIn } from './FadeIn';
export function Proof() {
  return <section className="py-10 sm:py-14 relative overflow-hidden" data-id="element-323">
      <div className="absolute inset-0 bg-gold/5 -skew-y-3 transform origin-bottom-right -z-10" data-id="element-324" />

      <div className="mx-auto max-w-4xl px-6 lg:px-8" data-id="element-325">
        <FadeIn data-id="element-326">
          <h2 className="text-3xl sm:text-4xl font-bold text-center mb-10 text-glow" data-id="element-327">
            Resultados que podés esperar
          </h2>
        </FadeIn>

        <div className="space-y-8 relative before:absolute before:inset-0 before:ml-5 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-transparent before:via-gold/30 before:to-transparent" data-id="element-328">
          {/* Day 3 */}
          <FadeIn direction="right" data-id="element-329">
            <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-330">
              <div className="flex items-center justify-center w-10 h-10 rounded-full border-4 border-navy bg-gold text-navy-dark font-bold shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 shadow-[0_0_20px_rgba(212,168,83,0.4)] z-10" data-id="element-331">
                3
              </div>
              <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] p-6 rounded-2xl bg-navy-light border border-white/10 shadow-xl" data-id="element-332">
                <h3 className="font-bold text-xl mb-2 text-gold-light" data-id="element-333">
                  Día 3
                </h3>
                <p className="text-slate-300 font-sans" data-id="element-334">
                  Notarás que los episodios de maullidos se acortan a la mitad.
                </p>
              </div>
            </div>
          </FadeIn>

          {/* Day 7 */}
          <FadeIn direction="left" delay={0.2} data-id="element-335">
            <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-336">
              <div className="flex items-center justify-center w-10 h-10 rounded-full border-4 border-navy bg-gold text-navy-dark font-bold shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 shadow-[0_0_20px_rgba(212,168,83,0.4)] z-10" data-id="element-337">
                7
              </div>
              <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] p-6 rounded-2xl bg-navy-light border border-white/10 shadow-xl" data-id="element-338">
                <h3 className="font-bold text-xl mb-2 text-gold-light" data-id="element-339">
                  Día 7
                </h3>
                <p className="text-slate-300 font-sans" data-id="element-340">
                  El gato empezará a esperar la sesión de juego en lugar de
                  despertarte a la madrugada, adoptando tu ritmo de sueño de
                  forma permanente.
                </p>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}